import React, { useRef, useState, useEffect } from 'react';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.css';

import { GalleryThumbnails as SThumbs } from './styled';

interface ApartmentsGalleryProps {
  photos: React.ReactElement[];
}

const ApartmentsGallery: React.FC<ApartmentsGalleryProps> = ({ photos }) => {
  const sliderMainRef = useRef<Slider | null>(null);
  const sliderThumbsRef = useRef<Slider | null>(null);
  const [navMain, setNavMain] = useState<Slider | null>(null);
  const [navThumbs, setNavThumbs] = useState<Slider | null>(null);

  useEffect(() => {
    setNavMain(sliderMainRef.current);
    setNavThumbs(sliderThumbsRef.current);
  }, []);

  const settingsMain: Settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false
  };

  const settingsThumbs: Settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    swipeToSlide: true,
    focusOnSelect: true,
    infinite: false,
    centerPadding: '10px'
  };

  return (
    <div>
      <Slider
        {...settingsMain}
        asNavFor={navThumbs ?? undefined}
        ref={slider => {
          sliderMainRef.current = slider;
        }}
      >
        {photos}
      </Slider>

      {photos?.length > 1 && (
        <SThumbs>
          <Slider
            {...settingsThumbs}
            asNavFor={navMain ?? undefined}
            ref={slider => {
              sliderThumbsRef.current = slider;
            }}
          >
            {photos}
          </Slider>
        </SThumbs>
      )}
    </div>
  );
};

export default ApartmentsGallery;
